query OrganizationEdit($id: ID!) {
  organization(id: $id) {
    id
    title
    altNames
    description
    slug
    website
    status
    logo {
      id
      url
    }
    platform {
      id
      title
    }
    currency
    feeSettings {
      feeType
      percentageFee
      fixedFeeAmount {
        value
        currency
      }
      providerFeePayer
    }
    assistant {
      enabled
      model
      monthlyBudgetUsd
    }
  }
}
